// client/src/routes/app/rent/payments.tsx — SCR-RENT-003 · PAY-003 (04 §8.5, §9.2.2).
//
// 04 §8.5 gives this screen the route `/app/rent/payments`, and §11.4's route tree lists it as
// `app/rent/payments.tsx`. There was no placeholder here to replace: UI-003's criterion is
// „all V1 MODULE routes exist in the sidebar", and 04 §6.2's sidebar has one row for this
// module — „Chirii & încasări" → `/app/rent`. So this route has no nav entry of its own and is
// reached from the board's header, which is where a landlord asking „ce am încasat" already is.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and
// the screen reads it back typed.
//
// The guard is `Payments.Read`, and the write code is nowhere near it. 03 §17.1 grants the
// accountant `Payments.Read` and NOT `Payments.Register`; reading the încasări is that role's
// job, and gating the route on the register code would answer SCR-SYS-403 to the one person
// whose work this screen is. That is precisely what BANK-004 had to undo (D-725), and D-707 is
// this item not repeating it: the screen is gated on the read, the storno and the reallocation
// on the write, and the API is the enforcement either way (04 §9.2.2).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { PaymentsList } from '@/features/payments/PaymentsList';
import { paymentSearchSchema, type PaymentSearch } from '@/features/payments/search';

export const Route = createFileRoute('/app/rent/payments')({
  validateSearch: paymentSearchSchema,
  component: PaymentsScreen,
});

function PaymentsScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Payments.Read">
      <PaymentsList
        search={search}
        onSearchChange={(next: (previous: PaymentSearch) => PaymentSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
